import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const SUPPORT_EMAIL = 'DL-AffiliatePortalSupport@charter.com';

const NoAffiliates: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" fontWeight="bold" color="textPrimary">
        No affiliates associated with your profile
      </Typography>
      <Typography variant="body1" color="textSecondary">
        The email was automatically sent to support.
      </Typography>
    </Box>
  );
};

export default NoAffiliates;
